import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

/**
 * BMC-Sonner: mappt die Toast-Farben auf die BMC-Tokens. Unsere Tokens halten
 * rohe HSL-Kanäle (z. B. `--popover: 240 21% 15%`), daher hier explizit mit
 * hsl(...) gewrappt — die @theme-inline-Wrapper greifen nur bei Utilities.
 *
 * Theme-agnostisch (CO-2): der Light/Dark-Modus wird als `theme`-Prop
 * hereingereicht (Default `system`), damit dieses UI-Primitive keine Kopplung
 * an den Editor-`ThemeContext` mehr braucht. Der Mount-Ort (ConsoleProviders)
 * liest das Theme und reicht es durch.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "hsl(var(--popover))",
          "--normal-text": "hsl(var(--popover-foreground))",
          "--normal-border": "hsl(var(--border))",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
